import React from 'react'

export default function Flex({justify="center", align="center", is_column = false, children, className=""}) {
    return (
        <div className={`d-flex justify-content-${justify} align-items-${align} ${is_column === true ? "flex-column" : ""} ${className}` }>
            {children}
        </div>
    )
}
